import userpfp from './../media/ctpfp.png';

export const CTData = [
    {
        ctname: 'Sania Paro',
        cticon: userpfp,
        ctage: 30,
        ctlocation: 'New York',
        ctprice: '$2000',
        ctexperience: '5 years',
        ctservices: 'Childcare, Elderly Care',
        ctreviews: [
            { name: 'John Doe', rating: 5, review: 'Great caretaker, very responsible.' },
            { name: 'Jane Smith', rating: 5, review: 'Very kind and attentive.' }
        ],
        status: 'Pending',
        ctphone: '5456543210'
    },
    {
        ctname: 'Neha Garg',
        cticon: userpfp,
        ctage: 28,
        ctlocation: 'Los Angeles',
        ctprice: '$1800',
        ctexperience: '5 years',
        ctservices: 'Childcare, Elderly Care',
        ctreviews: [
            { name: 'Alice Johnson', rating: 5, review: 'Neha is fantastic with kids!' },
            { name: 'Bob Brown', rating: 5, review: 'Very professional and punctual.' }
        ],
        status: 'Accepted',
        ctphone: '9876586710'
    },
    {
        ctname: 'Rahul Sethi',
        cticon: userpfp,
        ctage: 35,
        ctlocation: 'Chicago',
        ctprice: '$2200',
        ctexperience: '5 years',
        ctservices: 'Childcare, Elderly Care',
        ctreviews: [
            { name: 'Michael Lee', rating: 5, review: 'Rahul is very experienced and reliable.' },
            { name: 'Sarah Kim', rating: 5, review: 'He did a great job looking after my parents.' }
        ],
        status: 'Rejected',
        ctphone: '9345543210'
    },
    {
        ctname: 'Kajal Shah',
        cticon: userpfp,
        ctage: 32,
        ctlocation: 'San Francisco',
        ctprice: '$2100',
        ctexperience: '5 years',
        ctservices: 'Childcare, Elderly Care',
        ctreviews: [
            { name: 'David Wilson', rating: 5, review: 'Kajal is excellent and very caring.' },
            { name: 'Emma Davis', rating: 5, review: 'Highly recommend Kajal for elderly care.' }
        ],
        status: 'Pending',
        ctphone: '1236543210'
    },
    {
        ctname: 'Chirag Negi',
        cticon: userpfp,
        ctage: 29,
        ctlocation: 'Seattle',
        ctprice: '$1900',
        ctexperience: '5 years',
        ctservices: 'Childcare, Elderly Care',
        ctreviews: [
            { name: 'Chris Evans', rating: 5, review: 'Chirag is very attentive and kind.' },
            { name: 'Olivia Brown', rating: 5, review: 'He is great with pets and kids.' }
        ],
        status: 'Accepted',
        ctphone: '9876242210'
    }
];

export default CTData;